// extracted by mini-css-extract-plugin
export var form = "_43-0";